<template>
    <div>
        <div v-if="loading == false && error == false">
            <table class="table table-hover mb-0">
                <draggable
                    v-model="items"
                    tag="tbody"
                    handle=".handle"
                    :supportPointer="false"
                    :animation="100"
                    @change="syncSequence"
                >
                    <tr v-for="item in items" :key="item.id">
                        <td class="align-middle handle">
                            {{ item.name }}
                        </td>
                    </tr>
                </draggable>
            </table>
        </div>
    </div>
</template>

<script>
import draggable from 'vuedraggable';

export default {
    components: {
        draggable,
    },
    data() {
        return {
            items: [],
            loading: true,
            error: false,
        };
    },
    created() {
        this.fetchItems();
    },
    methods: {
        fetchItems() {
            this.loading = true;
            this.error = false;

            axios.get('/api/privacy-modules')
                .then(response => {
                    this.items = response.data;
                    this.loading = false;
                    this.error = false;
                }).catch(error => {
                    this.error = true;
                    this.loading = false;
                });
        },
        syncSequence() {
            let data = {items: this.items.map((item, index) => {
                return {index: index, id: item.id};
            })};

            axios.post('/api/privacy-modules/sort', data)
                .then(response => {

                });
        },
    },
}
</script>

<style scoped>
.handle {
    cursor: grab;
}
</style>